module.exports = __webpack_public_path__ + "assets/img/bUIPF8I-fUqDBN4vKzQWGg.24ece313.jpg";